import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import NotFound from '../Shared/NotFound';
import Login from '../Login/Login';
import DrawerPage from '../DrawerPage/DrawerPage';
import { useSelector } from 'react-redux';

function LoggedInRouter() {
  const loggedIn = useSelector((state) => state.userReducer.loggedIn);
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/404" component={NotFound} />
        <Route exact path={['/login/:reason', '/login']}>
          <Login />
        </Route>
        {!loggedIn && <Redirect to={'login'} />}
        <Route path={''}>
          <DrawerPage />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default LoggedInRouter;
